<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <!-- <config-hang >
          <img slot="config_hang_ele1" src="~assets/img/config/hostname.png" alt />
          <span slot="config_hang_ele2">{{serveHostData.gatewayName}}</span>
        </config-hang>-->
        <config-title-hang>
          <span slot="config_title_hang_ele2">主机信息</span>
          <img slot="config_title_hang_ele5_img" src="~assets/img/config/jiebang.png" alt @click="jieBangHostBtnHandle"
            v-if="serveHostData.userId != ''" />
          <span slot="config_title_hang_ele5" @click="jieBangHostBtnHandle"
            v-if="serveHostData.userId != ''">解绑主机</span>
        </config-title-hang>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/hostname.png" alt />
          <input class="input_public_ime_mode_none" slot="config_hang_input_left" type="text"
            v-model="serveHostData.gatewayName" />
        </config-input-row>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.uniqueCode16" :disabled="true" />
        </config-input-row>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/ip_hei.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.intranetIp" :disabled="true" />
        </config-input-row>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/luyou.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.gateway" :disabled="true" />
        </config-input-row>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/ziwang.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.subnetMask" :disabled="true" />
        </config-input-row>

        <!-- //代号 20231115-1  // 代号 20250202-1-->
        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/zhuji_hei.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.gatewayTypeName"
            :disabled="true" />
        </config-input-row>

        <config-input-row>
          <img slot="config_hang_input_img" src="~assets/img/config/banbenhao.png" alt />
          <input slot="config_hang_input_left" type="text" :placeholder="serveHostData.version" :disabled="true" />
        </config-input-row>

        <!-- //代号20220220-6 -->
        <div v-if="serveHostData.userId === ''" class="public_config_que_ren_btn" @click="addReturnBtnHandle">绑定</div>

        <div v-else class="public_config_que_ren_btn" @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigInputRow from '@/components/common/config/config-input-row';
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";
export default {
  data() {
    return {
      serveHostData: {
        ////服务器请求到的主机数据
        deleteState: 0,
        dropTime: "",
        extranetIp: "",
        gateway: "",
        gatewayId: "",
        gatewayName: "",
        intranetIp: "",
        mac: "",
        port: "",
        subnetMask: "",
        uniqueCode: "",
        uniqueCode16: "",
        gatewayTypeName: "", // 代号 20250202-1  
        userId: "",
        version: ""
      },
      oneHostData: {
        ////一个主机的信息
        // 代号 20240124-1
      }
    };
  },
  computed: {

  },
  components: {
    ConfigInputRow,
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    jieBangHostBtnHandle() {
      ///解绑主机按钮被点击了
      /// 解绑网关接口
      // console.log(this.$route.query)
      this.$showTipsToast(9, this.serveHostData);
    },
    saveReturnBtnHandle() {
      ////保存并返回按钮被点击了
      /// 修改网关基础信息(昵称)接口
      // console.log(this.$route.query)
      this.$request({
        method: "post",
        url: "/gateway/updateGatewayInfo",
        data: {
          token: this.$store.state.token,
          gatewayId: this.serveHostData.gatewayId,
          gatewayName: this.serveHostData.gatewayName
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            // 代号 20240124-1
            if (this.oneHostData.gatewayName != null || this.oneHostData.gatewayName != "") {
              this.oneHostData.gatewayName = this.serveHostData.gatewayName;
              this.$store.dispatch("asyUpdataoneHostData", this.oneHostData);
            }
            this.$showTipsToast(1, "修改成功", true); ////提示框
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addReturnBtnHandle() {
      ///添加并返回按钮点击了
      /// 绑定网关接口
      // console.log(this.$route.query)
      this.$request({
        method: "post",
        url: "/gateway/bindGatewayByGatewayId",
        data: {
          token: this.$store.state.token,
          gatewayId: this.serveHostData.gatewayId,
          gatewayName: this.serveHostData.gatewayName
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "绑定成功", true); ////提示框
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    // 代号 20240124-1
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    // console.log(this.oneHostData);
    /// 根据网关唯一码获取网关信息接口，获取数据
    console.log(this.$route.query);
    this.$request({
      method: "post",
      url: "/gateway/findGatewayByUniqueCode",
      data: {
        token: this.$store.state.token,
        uniqueCode16: this.$route.query.uniqueCode16
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
          // 代号 20250202-1  
          if (this.$route.query.type) {
            this.serveHostData.type = this.$route.query.type;
          }

        }
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style></style>